import React from 'react';
import styled from 'styled-components';
import {Button, COLORS, SIZES, Typography} from '@fupa/fupa-uikit';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${COLORS.white};
  padding: ${SIZES[32]};
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${SIZES[40]};
  height: ${SIZES[40]};
  background-color: ${COLORS.lighterGrey};
  border-radius: ${SIZES[20]};
  margin-bottom: ${SIZES[20]};
  font-family: ${SIZES[28]};
`;

const StyledTypography = styled(Typography)`
  margin-bottom: ${SIZES[20]};
  text-align: center;
`;

export const MyMatchesPlaceholder = ({icon, message, action}) => {
  const {onClick, label, actionIcon} = action;
  const showIcon = icon ? <IconContainer>{icon}</IconContainer> : null;

  return (
    <Wrapper>
      {showIcon}
      <StyledTypography variant='caption1'>{message}</StyledTypography>
      <Button label={label} onClick={onClick} icon={actionIcon ?? null} />
    </Wrapper>
  );
};
